import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateBrand, getSingleBrand } from "../modules/actions";

const mapStateToProps = (state) => ({
  state: {
    brandToEdit: state.brandReducer.brand,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateBrand,
      getSingleBrand
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
